import React, { useContext } from 'react';

import styled from '@emotion/styled';

import LeftArrowIcon from '../Icons/LeftArrowIcon';
import { TranslatingContainerContext } from '../TranslatingContainer/TranslatingContainerProvider';

interface PreviousSubmitBtnProps {
  children: React.ReactNode;
}

const PreviousSubmitBtn: React.FC<PreviousSubmitBtnProps> = ({ children }) => {
  const { setSliderIndexPos } = useContext(TranslatingContainerContext)!;

  const onClickBack = (e: any) => {
    setSliderIndexPos(-1);
  };

  return (
    <Button onClick={onClickBack} type='button'>
      <LeftArrowIcon />
      {children}
    </Button>
  );
};

export default PreviousSubmitBtn;

export const Button = styled.button`
  border: 1px solid ${({ theme }) => theme.palette.borderColor};
  border-radius: 6px;
  font-size: 16px;
  line-height: 16px;
  font-weight: 500;
  padding: 14px 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  background-color: white;
  color: ${({ theme }) => theme.palette.formDescriptionText};

  height: fit-content;
  cursor: pointer;
`;
